const key = 'PORTALS__';

exports.SET_CREATE_EDIT_PORTALS = `${key}SET_CREATE_EDIT_PORTALS`;
exports.SET_PORTALS_ID_TO_EDIT = `${key}SET_PORTALS_ID_TO_EDIT`;
